// NEW STYPEPARAMS METHOD
var GALLERY_TEXT_ALIGN = {
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
    CENTER: 'CENTER',
};
export default GALLERY_TEXT_ALIGN;
//# sourceMappingURL=behaviourParams_gallery_horizontal_slideshowInfo_buttonsAlignment.js.map